<template>
  <div>
    <DataTable
        class="mt-5"
        stripedRows
        :loading="isLoading"
        :value="currentTabState.tableData"
        :paginator="true"
        :rows="currentTabState.rowsPerPage"
        :totalRecords="currentTabState.totalRecords"
        :sortField="currentTabState.sortField"
        :sortOrder="currentTabState.sortOrder"
        :rowGroupMode="rowGroupMode"
        :groupRowsBy="groupRowsBy"
        selectionMode="single"
        @row-select="onRowSelect"
        @row-click="onRowClick"
        @page="onPageChange"
        @sort="onSort"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        :rowsPerPageOptions="[1, 2, 5, 10, 20]"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
        :lazy="true"
    >
      <!-- Standard columns -->
      <Column
          v-for="col in columns"
          :key="col.field"
          :field="col.field"
          :header="col.header"
          :sortable="col.sortable"
          :headerStyle="{ width: col.width }">
        >
        <!-- Custom slot content within Column if needed -->
        <template v-if="col.custom" #body="slotProps">
          <slot :name="col.slotName" :row-data="slotProps.data"/>
        </template>
      </Column>
      <template #empty>
        No records found.
      </template>
    </DataTable>
  </div>
</template>

<script>
import {mapState, mapActions} from "vuex";

export default {
  props: {
    columns: {
      type: Array,
      required: true,
    },
    rowGroupMode: {
      type: String,
      default: null
    },
    groupRowsBy: {
      type: String,
      default: null
    },
    enableRowClick: {
      type: Boolean,
      default: true
    },
  },
  computed: {
    ...mapState("repair", {
      currentTabState: state => state.tabs[state.currentTab],
      isLoading: state => state.isLoading,
    }),

  },
  methods: {
    ...mapActions("repair", ["updateTableSettings", "updateSortOptions"]),

    onRowSelect(event) {
      this.$emit("row-select", event);
    },
    onRowClick(event) {
      if (this.enableRowClick) {
        this.$emit("row-click", event);
      }
    },
    onPageChange(event) {
      this.updateTableSettings({
        rows: event.rows,
        page: event.page, // This is 0-based in the event
      });
    },
    onSort(event) {
      this.updateSortOptions({
        field: event.sortField,
        order: event.sortOrder,
      });
    },
  },
};
</script>
